<template>
  <div class="page-body">
    <b-card class="content-card">
      <BaseLoading
        v-if="reward.loading"
        class="p-5"
      />

      <div v-else>
        <div class="appbar-container">
          <h3 class="appbar-container__title">
            نمایش جزییات جایزه
          </h3>
          <b-button
            to="/reward-center/rewards/list"
            size="md"
            variant="primary"
            class="mr-1">
            بازگشت به لیست جایزه ها
          </b-button>
        </div>
        <div class="reward-details-container">
          <b-row class="reward-details-container__row">
            <b-col sm="12" class="text-right col-item">
                <span class="item-name">
                  تصویر :
                </span>
              <img :src="reward.image" style="width:60px;height: 60px" alt="">
            </b-col>

            <b-col sm="12" class="text-right col-item">
                <span class="item-name">
                  نام :
                </span>
              <span class="item-value">
                {{ reward.name }}
              </span>
            </b-col>

            <b-col sm="12" class="text-right col-item">
                <span class="item-name">
                  توضیحات :
                </span>
              <span class="item-value">
                {{ reward.description }}
              </span>
            </b-col>

            <b-col sm="12" class="text-right col-item">
                <span class="item-name">
                  وضعیت :
                </span>
              <span class="item-value">
                <badge :type="reward.active ? 'success' : 'danger'">
                  {{ reward.active ? 'فعال' : 'غیر فعال' }}
                </badge>
              </span>
            </b-col>

            <b-col sm="12" class="text-right col-item">
                <span class="item-name">
                  کمپین :
                </span>
              <span class="item-value">
                <badge :type="reward.campaign ? 'success' : 'danger'">
                  {{ reward.campaign ? 'دارد' : 'ندارد' }}
                </badge>
              </span>
            </b-col>

            <b-col sm="12" class="text-right col-item">
                <span class="item-name">
                  مدل جایزه :
                </span>
              <span class="item-value">
                {{ reward.action_type }}
              </span>
            </b-col>

            <b-col
              v-if="reward.fixed_value"
              sm="12" class="text-right col-item">
                <span class="item-name">
                  جایزه ثابت :
                </span>
              <span class="item-value">
                {{ reward.fixed_value }}
              </span>
            </b-col>


            <b-col
              v-if="reward.fixed_token"
              sm="12" class="text-right col-item">
                <span class="item-name">
                  رمزارز مشخص :
                </span>
              <span class="item-value">
                {{ reward.fixed_token }}
              </span>
            </b-col>


            <b-col
              v-if="reward.percent_value"
              sm="12" class="text-right col-item">
                <span class="item-name">
                  درصد :
                </span>
              <span class="item-value">
                {{ reward.percent_value }}
              </span>
            </b-col>

            <b-col
              v-if="reward.percentage_of_commission"
              sm="12" class="text-right col-item">
                <span class="item-name">
                  درصد از کمیسیون :
                </span>
              <span class="item-value">
                {{ reward.percentage_of_commission }}
              </span>
            </b-col>

            <b-col
              v-if="reward.t1"
              sm="12" class="text-right col-item">
                <span class="item-name">
                  مقدار :
                </span>
              <span class="item-value">
                {{ reward.t1 }}
              </span>
            </b-col>

            <b-col
              v-if="reward.portion_for_user"
              sm="12" class="text-right col-item">
                <span class="item-name">
                  درصد کاربر :
                </span>
              <span class="item-value">
                {{ reward.portion_for_user }}
              </span>
            </b-col>

            <b-col
              v-if="reward.portion_for_referrer"
              sm="12" class="text-right col-item">
                <span class="item-name">
                  درصد برای معرف:
                </span>
              <span class="item-value">
                {{ reward.portion_for_referrer }}
              </span>
            </b-col>

            <b-col
              v-if="reward.portion_for_2nd_referrer"
              sm="12" class="text-right col-item">
                <span class="item-name">
                  درصد برای معرف دوم :
                </span>
              <span class="item-value">
                {{ reward.portion_for_2nd_referrer }}
              </span>
            </b-col>

            <b-col
              v-if="reward.percent_of_each_type"
              sm="12" class="text-right col-item">
                <span class="item-name">
                  درصد از هر :
                </span>
              <span class="item-value">
                {{ reward.percent_of_each_type }}
              </span>
            </b-col>

            <b-col
              v-if="reward.time_type"
              sm="12" class="text-right col-item">
                <span class="item-name">
                  نوع ساختار زمانی:
                </span>
              <span class="item-value">
                {{ reward.time_type }}
              </span>
            </b-col>

            <b-col
              v-if="reward.d"
              sm="12" class="text-right col-item">
                <span class="item-name">
                  مقدار :
                </span>
              <span class="item-value">
                {{ reward.d }}
              </span>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {findReward} from "@/httpservices/Reward";
import moment from "jalali-moment";
import {BaseLoading} from "@/components";

const actionTypeValues = {
  FIXED: "FIXED",
  PERCENTAGE_OF_LAST: "PERCENTAGE_OF_LAST",
  PERCENTAGE_OF_HIGHEST: "PERCENTAGE_OF_HIGHEST",
  PERCENTAGE_OF_EACH: "PERCENTAGE_OF_EACH",
  PERCENTAGE_OF_EACH_CRYPTO_ON_TOKENS: "PERCENTAGE_OF_EACH_CRYPTO_ON_TOKENS",
  PERCENTAGE_OF_TOTAL: "PERCENTAGE_OF_TOTAL",
  PERCENTAGE_OF_TOTAL_BALANCE: "PERCENTAGE_OF_TOTAL_BALANCE",
  PERCENTAGE_OF_TOKEN_BALANCE: "PERCENTAGE_OF_TOKEN_BALANCE",
};
const percentageOfEachValues = {
  ALL: "ALL",
  TRADE: "TRADE",
  TRANSACTION: "TRANSACTION",
  TRANSACTION_CRYPTO: "TRANSACTION_CRYPTO",
  TRANSACTION_CRYPTO_TRADE: "TRANSACTION_CRYPTO_TRADE",
  TRANSACTION_FIAT: "TRANSACTION_FIAT",
  TRANSACTION_CRYPTO_DEPOSIT: "TRANSACTION_CRYPTO_DEPOSIT",
  TRANSACTION_CRYPTO_WITHDRAW: "TRANSACTION_CRYPTO_WITHDRAW",
  TRANSACTION_FIAT_DEPOSIT: "TRANSACTION_FIAT_DEPOSIT",
  TRANSACTION_FIAT_WITHDRAW: "TRANSACTION_FIAT_WITHDRAW",
};
const percentageOfEachCryptoValues = {
  ALL: "ALL",
  TRADE: "TRADE",
  TRANSACTION: "TRANSACTION",
  TRANSACTION_CRYPTO_DEPOSIT: "TRANSACTION_CRYPTO_DEPOSIT",
  TRANSACTION_CRYPTO_WITHDRAW: "TRANSACTION_CRYPTO_WITHDRAW",
};
const timeTypeValues = {
  EVERYDAY_FOR: "EVERYDAY_FOR",
  EVERYDAY_FROM_TO: "EVERYDAY_FROM_TO",
  OVER_ANY_RANGE_OF: "OVER_ANY_RANGE_OF",
  OVER_FROM_TO: "OVER_FROM_TO",
  ANY_DAY_FROM_TO: "ANY_DAY_FROM_TO",
  AT: "AT",
  ANYTIME: "ANYTIME",
};


export default {
  name: "RewardDetails",

  data() {
    return {
      actionTypeOptions: [
        {
          value: actionTypeValues.FIXED,
          text: 'جایزه ثابت',
        },
        {
          value: actionTypeValues.PERCENTAGE_OF_LAST,
          text: 'درصد از اخرین',
        },
        {
          value: actionTypeValues.PERCENTAGE_OF_HIGHEST,
          text: 'درصد از بالاترین',
        },
        {
          value: actionTypeValues.PERCENTAGE_OF_EACH,
          text: 'درصد از هر',
        },
        {
          value: actionTypeValues.PERCENTAGE_OF_EACH_CRYPTO_ON_TOKENS,
          text: 'درصد از هر رمزارز',
        },
        {
          value: actionTypeValues.PERCENTAGE_OF_TOTAL,
          text: 'درصد از کل',
        },
        {
          value: actionTypeValues.PERCENTAGE_OF_TOTAL_BALANCE,
          text: 'درصد از کل موجودی',
        },
        {
          value: actionTypeValues.PERCENTAGE_OF_TOKEN_BALANCE,
          text: 'درصد از موجودی رمزارز',
        },
      ],
      percentageOfEachOptions: [
        {
          value: percentageOfEachValues.ALL,
          text: "همه",
        },
        {
          value: percentageOfEachValues.TRADE,
          text: "ترید",
        },
        {
          value: percentageOfEachValues.TRANSACTION,
          text: "تراکنش",
        },
        {
          value: percentageOfEachValues.TRANSACTION_CRYPTO,
          text: "تراکنش رمزارز",
        },
        {
          value: percentageOfEachValues.TRANSACTION_CRYPTO_TRADE,
          text: "تراکنش و ترید رمزارز",
        },
        {
          value: percentageOfEachValues.TRANSACTION_FIAT,
          text: "تراکنش تومانی",
        },
        {
          value: percentageOfEachValues.TRANSACTION_CRYPTO_DEPOSIT,
          text: "واریز رمزارز",
        },
        {
          value: percentageOfEachValues.TRANSACTION_CRYPTO_WITHDRAW,
          text: "برداشت رمزارز",
        },
        {
          value: percentageOfEachValues.TRANSACTION_FIAT_DEPOSIT,
          text: "واریز تومان",
        },
        {
          value: percentageOfEachValues.TRANSACTION_FIAT_WITHDRAW,
          text: "برداشت تومان",
        },
      ],
      percentageOfEachCryptoOptions: [
        {
          value: percentageOfEachCryptoValues.ALL,
          text: "همه"
        },
        {
          value: percentageOfEachCryptoValues.TRADE,
          text: "ترید"
        },
        {
          value: percentageOfEachCryptoValues.TRANSACTION,
          text: "تراکنش"
        },
        {
          value: percentageOfEachCryptoValues.TRANSACTION_CRYPTO_DEPOSIT,
          text: "واریز رمزارز"
        },
        {
          value: percentageOfEachCryptoValues.TRANSACTION_CRYPTO_WITHDRAW,
          text: "برداشت رمزارز"
        },
      ],
      timeTypeOptions: [
        {
          value: timeTypeValues.EVERYDAY_FOR,
          text: "روز متوالی"
        },
        {
          value: timeTypeValues.EVERYDAY_FROM_TO,
          text: "هر روز از"
        },
        {
          value: timeTypeValues.OVER_ANY_RANGE_OF,
          text: "در هر بازه زمانی"
        },
        {
          value: timeTypeValues.OVER_FROM_TO,
          text: "در یک بازه زمانی"
        },
        {
          value: timeTypeValues.ANY_DAY_FROM_TO,
          text: "هر روز در یک بازه زمانی"
        },
        {
          value: timeTypeValues.AT,
          text: "در تاریخ"
        },
        {
          value: timeTypeValues.ANYTIME,
          text: "هر زمانی"
        },
      ],

      reward: {
        loading: true,
      }
    }
  },

  components:{
    BaseLoading
  },

  mounted() {
    this.fetchData(this.$route.params.id);
  },

  methods: {
    fetchData(id) {
      const getImage = (item) => {
        if (item.reward_image_url) {
          return process.env.VUE_APP_REWARD_CENTER_BASE_URL + item.reward_image_url;
        }
        return '/img/placeholder-image.jpg';
      }


      this.reward.loading = true;

      findReward(id)
        .then(res => {
          this.reward = {
            ...this.reward,
            loading: false,
            ...res.data,
            date_from: res.data.date_from && moment(res.data.date_from).locale('fa').format('jYYYY-jMM-JDD'),
            date_to: res.data.date_to && moment(res.data.date_to).locale('fa').format('jYYYY-jMM-JDD'),
            date_at: res.data.date_at && moment(res.data.date_at).locale('fa').format('jYYYY-jMM-JDD'),
            image: getImage(res.data),
            action_type: (this.actionTypeOptions.find(i => i.value === res.data.action_type) || {}).text,
            time_type: (this.timeTypeOptions.find(i => i.value === res.data.time_type) || {}).text,
          }
        })
        .catch(e => {
          console.log(e)
        });
    }
  },


}
</script>

<style lang="scss" scoped>

.reward-details-container {
  &__row {
    .col-item {
      padding: 10px;
    }

    .col-item:nth-child(even) {
      background-color: #eee;
    }
  }
}


.appbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  &__title {
    font-size: 20px;
  }
}

.item-name {
  font-size: 15px;
  font-weight: bold;
  min-width: 200px;
  display: inline-flex;
}

.item-value {
  font-size: 14px;
}

</style>
